<template>
  <div class="page-frame">
    <section class="logistics-info" v-if="logistics.packageList && logistics.packageList.length && logistics.packageList[index]">
      <ul class="flex logistics-info__head">
        <li>
         
          <img src="../../assets/imgs/kuaidi.png" style="width: 32px;height: 32px" alt="">
        </li>
        <li class=" flex space-between" style="width: 100%" v-if="logistics.packageList[index].logisticsResp">
          <div>
            <h2>
            物流状态：
            <span>{{ logStatsMap[logistics.packageList[index].logisticsResp.expressStatus] }}</span>
          </h2>
          <div class="desc">
            快递公司：
            <span>{{ logistics.packageList[index].logisticsResp.expressComName }}</span>
          </div>
          <div class="desc" style="padding-bottom: 4px">
            快递单号：
            <span>{{ logistics.packageList[index].logisticsResp.expressNo}}</span>
          </div>
          </div>
          <div class="align-self-end" >
            <van-button  type="default" plain size="mini" color="#d9d9d9" width="56px" ref="copy" :data-clipboard-text="logistics.packageList[index].logisticsResp.expressNo" round>
              <span style="color: #595959">复制</span>
            </van-button>
          </div>
          

          
        </li>
      </ul>
      <section class="logistics-info__list">
        <van-steps direction="vertical" active-icon="dot" :active="0">
          <van-step v-for="(item, index) in logistics.packageList[index].logisticsTraceRespList" :key="index">
            <h3 class="location">{{ item.content }}</h3>
            <p class="time">{{ item.time }}</p>
          </van-step>
        </van-steps>
        <p class="description">
          <!-- 临时审计合规需求 -->
          以上物流信息由第三方服务提供
        </p>
      </section>
    </section>
  </div>
</template>

<script>
import { ZYToast } from '@zyf2e/adapt';
import { logStatsMap } from '@/constant/enum'
import Clipboard from 'clipboard';


export default {
  data() {
    return {
      logistics: {
        packageList: []
      },
      logStatsMap,
      index: 0
    };
  },
  async created() {
    // 审计合规需求
    // this.setWAitFlag();

    const { id } = this.$route.params;
    // const { expressUrl } = this.$route.query;

    const logisticsTemp = await this.$fetch.getOrderExpressList({
      orderId: id
    });
    
    // 审计合规需求
    // setTimeout(() => {
      this.logistics = logisticsTemp;
      this.$nextTick(()=> {
        setTimeout(() => {
          this.initClipBoard()
        }, 1000);
    })
    

    this.index = Number(this.$route.query.index) || 0;
  },
  methods: {
    initClipBoard() {
      
      const clipboard = new Clipboard(this.$refs.copy);
      clipboard.on('success', e => {
        this.$toast('复制成功');
        e.clearSelection();
      });
    },
    // 审计合规需求
    // setWAitFlag() {
    //   if (window.wait3secFlag) return;
    //   window.wait3secFlag = true;
    //   const oldToast = ZYToast;
    //   const oldSuccess = ZYToast.success;
    //   ZYToast.success = () => {
    //     if (this.$route.name === 'logistics') {
    //       setTimeout(() => {
    //         oldSuccess.call(oldToast);
    //       }, 3000);
    //     } else {
    //       oldSuccess.call(oldToast);
    //     }
    //   };
    // }
  }
};
</script>

<style lang="less" scoped>
.page-frame {
  height: 100%;
  width: 100%;
  background: @background-color-light;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  .page-main.flex-1 {
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }
}
.logistics-info {
  &__list {
    margin-top: 12px;
    // padding: 20px 12px;
    padding: 14px 0 12px 0;
    background: @white;
    .description {
      color: @gray-6;
      margin-bottom: 20px;
      margin-left: 32px;
      font-size: @font-size-sm;
    }

    .active-icon {
      width: 8px;
      height: 8px;
    }
    /deep/ .van-step:first-child .location {
      color: #1E8DFF;
    }
    /deep/ .van-step:first-child .time {
      color: #1E8DFF;
      
    }

    .location {
      line-height: 21/14;
      color: #BFBFBF;
      font-size: 14px;
    }
    .time {
      margin-top: 4px;
      color: #BFBFBF;
      font-size: 12px;
      margin-bottom: 48px;
    }
    /deep/ .van-step:last-child .time {
      margin-bottom: 24px;
      
    }
  }
  &__head {
    background: @white;
    padding: 12px;
    li {
      margin-left: 12px;
      h2 {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
        span {
          color: @green;
        }
      }
      .desc {
        line-height: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #8C8C8C;
        margin-top: 8px
      }
    }
    
  }

  /deep/ .van-icon-dot {
    width: 8px;
    height: 8px;
    background-color: #1E8DFF;
    border-radius: 50%;
    &::after {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: rgba(30, 141, 255, 0.16);
      top: -4px;
      left: -4px;
      
    }
  }
  /deep/ [class*='van-hairline']::after {
    border: 0 solid transparent;  
  }

  /deep/ .van-step--vertical .van-step__line {
    top: 20%;
    // left: -15px;
    // width: 1px;
    height: 88%;
}
/deep/ .van-step--vertical .van-step__circle-container {
    position: absolute;
    top: 19px;
    left: -14px;
    z-index: 2;
    font-size: 12px;
    line-height: 1;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
/deep/ .van-step__circle {
    display: block;
    width: 8px;
    height: 8px;
    background: #D9D9D9;
    border-radius: 50%;
    position:relative;
   
}
}
</style>
